// db value used when select/multi-select has custom(free text) other option
export const SELECT_CUSTOM_OTHER_DB_VALUE = 999999;
